import { TranslateService } from '@ngx-translate/core';
import { Component, Input, OnInit } from '@angular/core';
import { LayoutService } from '../../services/layout.service';
import emojioneEN from '@iconify/icons-emojione/flag-for-flag-united-kingdom';
import emojioneIT from '@iconify/icons-emojione/flag-for-flag-italy';
import icMenu from '@iconify/icons-ic/twotone-menu';
import { ConfigService } from '../../services/config.service';
import { map } from 'rxjs/operators';
import { NavigationService } from '../../services/navigation.service';
import { Style, StyleService } from 'src/@vex/services/style.service';
import { DateAdapter } from '@angular/material/core';

@Component({
  selector: 'vex-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.scss']
})
export class ToolbarComponent implements OnInit {
  @Input() mobileQuery: boolean;

  isLightStyle =
    !localStorage.getItem('theme') ||
    localStorage.getItem('theme') === Style.dark;
  navigationItems = this.navigationService.items;
  isHorizontalLayout$ = this.configService.config$.pipe(
    map(config => config.layout === 'horizontal')
  );
  isVerticalLayout$ = this.configService.config$.pipe(
    map(config => config.layout === 'vertical')
  );
  isNavbarInToolbar$ = this.configService.config$.pipe(
    map(config => config.navbar.position === 'in-toolbar')
  );
  isNavbarBelowToolbar$ = this.configService.config$.pipe(
    map(config => config.navbar.position === 'below-toolbar')
  );

  emojioneEN = emojioneEN;
  emojioneIT = emojioneIT;
  icMenu = icMenu;
  currentLangIcon = emojioneEN;

  constructor(
    private layoutService: LayoutService,
    private configService: ConfigService,
    private navigationService: NavigationService,
    private styleService: StyleService,
    private adapter: DateAdapter<any>,
    private translate: TranslateService
  ) {}

  ngOnInit() {
    const currentLang = localStorage.getItem('language')
      ? localStorage.getItem('language')
      : 'en';
    this.translate.use(currentLang);
    this.adapter.setLocale(currentLang);
    this.currentLangIcon = eval('this.emojione' + currentLang.toUpperCase());
  }

  openSidenav() {
    this.layoutService.openSidenav();
  }

  switchLanguage(language: string) {
    const lang = language.toLowerCase();
    this.translate.use(lang);
    localStorage.setItem('language', lang);
    this.adapter.setLocale(lang);
    this.currentLangIcon = eval('this.emojione' + lang.toUpperCase());
  }
}
